export default {
  buttons: {
    next: "Далее",
    prev: "Назад",
    skip: "Пропустить",
    done: "Готово",
    gotIt: "Ясно",
  },
  messages: {
    dontShowAgainLabel: "Больше не показывать",
    stepNumbersOfLabel: "из",
  },
};
